import { render, staticRenderFns } from "./widget_header.vue?vue&type=template&id=0ed2b805&scoped=true&lang=pug"
import script from "./widget_header.vue?vue&type=script&lang=js"
export * from "./widget_header.vue?vue&type=script&lang=js"
import style0 from "./widget_header.vue?vue&type=style&index=0&id=0ed2b805&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed2b805",
  null
  
)

export default component.exports